import throttle from '../plugins/throttle';

export default () => {

  $('html')
    // Toggle [aria-expanded] attribute on nav items with dropdowns
    .on('mouseenter mouseleave', '.site-header-navbar-item a[aria-haspopup="true"]', (e) => {
      $(e.currentTarget).attr('aria-expanded', e.type === 'mouseenter' ? 'true' : 'false');
    })
    // Toggle [aria-expanded] attribute on nav items with dropdowns
    .on('mouseenter mouseleave', '.site-header-navbar-item-dropdown', (e) => {
      $(e.currentTarget).prev().attr('aria-expanded', e.type === 'mouseenter' ? 'true' : 'false').toggleClass('-hovered');
    })
    // Open header search
    .on('click', '.js-site-header-search-open', (e) => {
      e.preventDefault();
      $('.js-site-header-search')
        .addClass('-open')
        .fadeToggle(150)
        .find('.js-site-header-search-input')
        .trigger('focus')
      ;
    })
    // Close header search
    .on('click', '.js-site-header-search-close', (e) => {
      e.preventDefault();
      $('.js-site-header-search').removeClass('-open').fadeToggle(150);
    })
    .on('keydown', '.js-site-header-search-input', (e) => {
      if (e.keyCode === 27) {
        e.preventDefault();
        $('.js-site-header-search').removeClass('-open').fadeToggle(150);
      }
    })
    // Open mobile nav
    .on('click', '.js-mobile-nav-open', (e) => {
      e.preventDefault();
      $('html').attr('data-nav-open', 'true');
    })
    // Close mobile nav
    .on('click', '.mobile-nav-close', (e) => {
      e.preventDefault();
      $('html').attr('data-nav-open', 'false');
    })
  ;

  // Size filter panel on resize
  $(window).on('resize', throttle(function() {
    $('html').attr('data-nav-open', 'false');

    if ($(window).width() < 900) {
      $('.js-site-header-search').fadeOut(150);
    }

  }, 100));

};

//
